import React from 'react';
import {
    Box,
    Grid,
    Typography,
    Card,
    CardContent,
    CardMedia,
    Container
} from '@mui/material';

const newsItems = [
    {
        title: 'Казахстан представил инвестиционные проекты на сессии ОЭСР в Париже',
        image: 'news/5.jpg',
        date: '23 апреля 2024'
    },
    {
        title: 'Kazakh Invest и DP World обсудили вопросы локализации производства',
        image: 'news/6.jpg',
        date: '11 апреля 2024'
    },
    {
        title: 'Kazakh Invest договорились о финансовых льготах с Китаем',
        image: 'news/1.jpg',
        date: '5 апреля 2024'
    },
    {
        title: 'ЕБРР и Kazakh Invest договорились о финансовом сотрудничестве ',
        image: 'news/2.jpg',
        date: '5 апреля 2024'
    },
    {
        title: 'Kazakh Invest провел встречи с представителями Чехии ',
        image: 'news/3.jpg',
        date: '14 марта 2024'
    },
    {
        title: 'Kazakh Invest провел встречи с представителями Норвегии',
        image: 'news/4.jpg',
        date: '24 марта 2024'
    }
];

const KazakhInvestNews: React.FC = () => {
    // Split news items into two rows
    const firstRowItems = newsItems.slice(0, 2);
    const secondRowItems = newsItems.slice(2, 6);

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom fontWeight={600}>
                Последние новости
            </Typography>

            {/* First row - 2 bigger news items */}
            <Grid container spacing={3} sx={{ mb: 3 }}>
                {firstRowItems.map((item, index) => (
                    <Grid item xs={12} sm={6} md={6} key={index}>
                        <Card sx={{ height: '100%' }}>
                            <CardMedia
                                component="img"
                                height="240"
                                image={item.image}
                                alt={item.title}
                            />
                            <CardContent>
                                <Typography variant="caption" color="text.secondary">
                                    {item.date}
                                </Typography>
                                <Typography variant="subtitle1" fontWeight="bold" color="text.primary" gutterBottom>
                                    {item.title}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* Second row - 4 smaller news items */}
            <Grid container spacing={3}>
                {secondRowItems.map((item, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index + 2}>
                        <Card sx={{ height: '100%' }}>
                            <CardMedia
                                component="img"
                                height="160"
                                image={item.image}
                                alt={item.title}
                            />
                            <CardContent>
                                <Typography variant="caption" color="text.secondary">
                                    {item.date}
                                </Typography>
                                <Typography variant="subtitle1" fontWeight="bold" color="text.primary" gutterBottom>
                                    {item.title}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default KazakhInvestNews;
